/** Public contact details shown on the support page and in the footer. */
export const SUPPORT_EMAIL = 'hp@lamidconsulting.com';

// TODO: replace with LAMID's real profile URLs and WhatsApp number (wa.me/<countrycode><number>).
export const SOCIAL_LINKS = {
  linkedin: 'https://www.linkedin.com/',
  facebook: 'https://www.facebook.com/',
  tiktok: 'https://www.tiktok.com/',
  whatsapp: 'https://wa.me/',
} as const;
